export default "__VITE_ASSET__eb435c57__"